import type { AxiosResponse } from "axios";
import apiClient from "./client";
import { parseContentDispositionFilename } from "./user-master";

type ApiErrorBody = {
  message?: string;
};

export type SiteByUsersDownloadOk = {
  status: "ok";
  blob: Blob;
  filename: string;
};

export type SiteByUsersDownloadNg = {
  status: "ng";
  message: string;
};

export type SiteByUsersDownloadResult =
  | SiteByUsersDownloadOk
  | SiteByUsersDownloadNg;

export type SiteByUsersDownloadParams = {
  domain: string;
};

export const downloadSiteByUsers = async (
  disasterId: number | string,
  params: SiteByUsersDownloadParams
): Promise<AxiosResponse<Blob>> => {
  return apiClient.get<Blob>(`/sitebyusers-download/${disasterId}`, {
    params: {
      domain: params.domain,
    },
    responseType: "blob",
  });
};

export const parseSiteByUsersDownloadResponse = async (
  response: AxiosResponse<Blob>
): Promise<SiteByUsersDownloadResult> => {
  const blob = response.data;
  if (blob.type === "application/json") {
    const text = await blob.text();
    try {
      const parsed = JSON.parse(text) as ApiErrorBody;
      return {
        status: "ng",
        message: parsed.message || "ダウンロードに失敗しました",
      };
    } catch {
      return { status: "ng", message: "ダウンロードに失敗しました" };
    }
  }

  const header =
    response.headers["content-disposition"] ||
    response.headers["Content-Disposition"];
  const filename =
    parseContentDispositionFilename(header) || "SS毎アカウントリスト.xlsx";

  return { status: "ok", blob, filename };
};
